import { MutationTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyKorfineTypesStore from "./property-korfine-types.store";
import Vue from "vue";
import { IKorfineEstate, IKorfineOwner, IKorfineRequestModel, IKorfineTenant, KorfineContractModel, KorfineEstate, KorfineOwner, KorfineRequestModel, KorfineTenant } from "../../../../models/property/property-korfine.model";

const korfineMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
    [propertyKorfineTypesStore.Set.KORFINE_REQUEST_INFO]: (
        state: IPropertyEditState,
        param: IKorfineRequestModel
    ) => {

    },
    [propertyKorfineTypesStore.Set.KORFINE_ASSIGN_VALUE]: (state: IPropertyEditState, korfine: KorfineRequestModel) => {
        Object.keys(korfine).forEach(key => Vue.set(state.korfine, key, korfine[key]))
    },
    [propertyKorfineTypesStore.Set.CONTRACT_ASSIGN_VALUE]: (state: IPropertyEditState, korfine: KorfineContractModel) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        Object.keys(korfine).forEach(key => Vue.set(state.korfine.Contract, key, korfine[key]))
    },
    [propertyKorfineTypesStore.Set.OWNER_ASSIGNVALUE]: (state: IPropertyEditState, korfine: IKorfineOwner) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        if (!state.korfine.Contract.Owner) {
            Vue.set(state.korfine.Contract, 'Owner', {});
        }
        Object.keys(korfine).forEach(key => Vue.set(state.korfine.Contract.Owner, key, korfine[key]))
    },
    [propertyKorfineTypesStore.Set.OWNER_RESET]: (state: IPropertyEditState) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        state.korfine.Contract.Owner = new KorfineOwner({});
    },
    [propertyKorfineTypesStore.Set.TENANT_ASSIGNVALUE]: (state: IPropertyEditState, korfine: IKorfineTenant) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        if (!state.korfine.Contract.Tenant) {
            Vue.set(state.korfine.Contract, 'Tenant', {});
        }
        Object.keys(korfine).forEach(key => Vue.set(state.korfine.Contract.Tenant, key, korfine[key]))
    },
    [propertyKorfineTypesStore.Set.TENANT_RESET]: (state: IPropertyEditState) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        state.korfine.Contract.Tenant = new KorfineTenant({});
    },
    [propertyKorfineTypesStore.Set.ESTATE_ASSIGNVALUE]: (state: IPropertyEditState, korfine: IKorfineEstate) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        if (!state.korfine.Contract.Estate) {
            Vue.set(state.korfine.Contract, 'Estate', {});
        }
        Object.keys(korfine).forEach(key => Vue.set(state.korfine.Contract.Estate, key, korfine[key]))
    },
    [propertyKorfineTypesStore.Set.ESTATE_RESET]: (state: IPropertyEditState) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        state.korfine.Contract.Estate = new KorfineEstate({});
    },
    [propertyKorfineTypesStore.Set.OWNER_PERSON_ASSIGNVALUE]: (state: IPropertyEditState, korfine: IKorfineEstate) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        if (!state.korfine.Contract.Owner) {
            Vue.set(state.korfine.Contract, 'Owner', {});
        }
        if (!state.korfine.Contract.Owner.Person) {
            Vue.set(state.korfine.Contract.Owner, 'Person', {});
        }
        Object.keys(korfine).forEach(key => Vue.set(state.korfine.Contract.Owner.Person, key, korfine[key]))
    },
    [propertyKorfineTypesStore.Set.OWNER_PARTNER_ASSIGNVALUE]: (state: IPropertyEditState, korfine: IKorfineEstate) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        if (!state.korfine.Contract.Owner) {
            Vue.set(state.korfine.Contract, 'Owner', {});
        }
        if (!state.korfine.Contract.Owner.Partner) {
            Vue.set(state.korfine.Contract.Owner, 'Partner', {});
        }
        Object.keys(korfine).forEach(key => Vue.set(state.korfine.Contract.Owner.Partner, key, korfine[key]))
    },
    [propertyKorfineTypesStore.Set.TENANT_PERSON_ASSIGNVALUE]: (state: IPropertyEditState, korfine: IKorfineEstate) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        if (!state.korfine.Contract.Tenant) {
            Vue.set(state.korfine.Contract, 'Tenant', {});
        }
        if (!state.korfine.Contract.Tenant.Person) {
            Vue.set(state.korfine.Contract.Tenant, 'Person', {});
        }
        Object.keys(korfine).forEach(key => Vue.set(state.korfine.Contract.Tenant.Person, key, korfine[key]))
    },
    [propertyKorfineTypesStore.Set.TENANT_PARTNER_ASSIGNVALUE]: (state: IPropertyEditState, korfine: IKorfineEstate) => {
        if (!state.korfine.Contract) {
            Vue.set(state.korfine, 'Contract', {});
        }
        if (!state.korfine.Contract.Tenant) {
            Vue.set(state.korfine.Contract, 'Tenant', {});
        }
        if (!state.korfine.Contract.Tenant.Partner) {
            Vue.set(state.korfine.Contract.Tenant, 'Partner', {});
        }
        Object.keys(korfine).forEach(key => Vue.set(state.korfine.Contract.Tenant.Partner, key, korfine[key]))
    },
    [propertyKorfineTypesStore.Set.KORFINE_RESET]: (state: IPropertyEditState) => {
        Vue.set(state.korfine, 'Contract', {});
        Vue.set(state.korfine.Contract, 'Tenant', {});
        Vue.set(state.korfine.Contract.Tenant, 'Partner', {});
        Vue.set(state.korfine.Contract.Tenant, 'Person', {});

        Vue.set(state.korfine.Contract, 'Owner', {});
        Vue.set(state.korfine.Contract.Owner, 'Partner', {});
        Vue.set(state.korfine.Contract.Owner, 'Person', {});
    },
};

export default korfineMutations;